/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The constants for footer buttons
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { IAccess } from '../../types/guardTypes';
import { AccessComponentKeyEnum } from './guardConstants';

export const FooterButtonsAccess: IAccess = {
    [AccessComponentKeyEnum.FooterButtonAccessLevels]: {},
    [AccessComponentKeyEnum.FooterButtonAdditionalAccount]: {},
    [AccessComponentKeyEnum.FooterButtonAdditionalReports]: {},
    [AccessComponentKeyEnum.FooterButtonBalanceUpdate]: {},
    [AccessComponentKeyEnum.FooterButtonBills]: {},
    [AccessComponentKeyEnum.FooterButtonCallDetails]: {},
    [AccessComponentKeyEnum.FooterButtonDcruleChange]: {},
    [AccessComponentKeyEnum.FooterButtonDcruleList]: {},
    [AccessComponentKeyEnum.FooterButtonExpenses]: {},
    [AccessComponentKeyEnum.FooterButtonInquiryCreate]: {},
    [AccessComponentKeyEnum.FooterButtonInvoiceRepayment]: {},
    [AccessComponentKeyEnum.FooterButtonLabels]: {},
    [AccessComponentKeyEnum.FooterButtonLock]: {},
    [AccessComponentKeyEnum.FooterButtonMoneyTransfer]: {},
    [AccessComponentKeyEnum.FooterButtonPayment]: {},
    [AccessComponentKeyEnum.FooterButtonRateServicesAndTariffOptions]: {},
    [AccessComponentKeyEnum.FooterButtonReports]: {},
    [AccessComponentKeyEnum.FooterButtonTariffChange]: {},
};
